import { getColor } from '../utils/constants'
import changePolyline from '../polylines/changePolyline'
import getPolylineByFromId from '../polylines/getPolylineByFromId'
import { planeSymbolDefault, planeSymbolHover } from '../polylines/symbols'

const bindHover = items => {
  items.each((i, item) => {
    let id = null
    let polyline = {}
    let currentFromId = null

    $(item).on('mouseenter', function() {
      id = parseInt($(item).attr('data-result-list-item-id'))
      polyline = getPolylineByFromId(id)

      $(`#marker-${id}`).addClass('selected-route')
      $(`#marker-${polyline.toId}`).addClass('selected-route')

      changePolyline(polyline, {
        strokeColor: getColor('POLYLINE_HOVER'),
        // strokeColor: '#ed1847',
        icons: [{
          icon: planeSymbolHover(),
          offset: `${polyline.planePosition}%`
          // offset: '100%'
        }],
      })
    })

    $(item).on('mouseleave', function() {
      $(`#marker-${id}`).removeClass('selected-route')
      $(`#marker-${polyline.toId}`).removeClass('selected-route')

      changePolyline(polyline, {
        strokeColor: getColor('POLYLINE'),
        icons: [{
          icon: planeSymbolDefault(),
          offset: `${polyline.planePosition}%`
        }],
      })
    })
  })
}

export default bindHover



// WEBPACK FOOTER //
// ./app/result-list/bindHover.js